import { DispatchedAmountType } from '../enums';
export class DispatchedAmountTypeLookup {
    getLookup() {
        let dispatchedAmountTypes = [];
        dispatchedAmountTypes.push({ label: 'Actual', value: DispatchedAmountType.Actual });
        dispatchedAmountTypes.push({ label: 'Calculated', value: DispatchedAmountType.Calculated });
        return dispatchedAmountTypes
    };
}
